'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_OAuthUserData$$anon$5(ps$9) {
  this.a6y = null;
  this.a6y = ps$9;
}
export { $c_Lmealorama_OAuthUserData$$anon$5 as $c_Lmealorama_OAuthUserData$$anon$5 };
$p = $c_Lmealorama_OAuthUserData$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_OAuthUserData$$anon$5;
/** @constructor */
function $h_Lmealorama_OAuthUserData$$anon$5() {
}
export { $h_Lmealorama_OAuthUserData$$anon$5 as $h_Lmealorama_OAuthUserData$$anon$5 };
$h_Lmealorama_OAuthUserData$$anon$5.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6y.a.length;
});
$p.g = (function(i) {
  return this.a6y.a[i];
});
var $d_Lmealorama_OAuthUserData$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_OAuthUserData$$anon$5, "mealorama.OAuthUserData$$anon$5", ({
  GG: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_OAuthUserData$$anon$5 as $d_Lmealorama_OAuthUserData$$anon$5 };
//# sourceMappingURL=mealorama.-O-Auth-User-Data$$anon$5.js.map
